var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mini_wrap" },
    [
      _c(
        "swiper",
        {
          staticClass: "swiper-no-swiping",
          attrs: { id: "swiper", options: _vm.swiperOption }
        },
        [
          _vm._l(_vm.resourceData, function(data, index) {
            return _c(
              "swiper-slide",
              {
                key: data.id,
                class:
                  (data.id == _vm.resourceId ? "swiper_active" : "") +
                  (_vm.resourceData.length > 5 &&
                  index == _vm.resourceData.length - 1
                    ? " last_swiper"
                    : "")
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: { width: "100%", height: "100%" },
                    on: {
                      click: function($event) {
                        return _vm.selectCurrent(data, index)
                      }
                    }
                  },
                  [
                    data.type == 1
                      ? _c("div", { staticClass: "resource_tag" }, [
                          _c("i", { staticClass: "pic" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("图片")]),
                          _vm._v(" "),
                          data.taskType === 1 && _vm.sign != "preview"
                            ? _c("img", {
                                attrs: {
                                  src:
                                    data.isFinish === 1
                                      ? _vm.isFinish
                                      : _vm.unFinish
                                }
                              })
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    data.type == 2 || data.type == 5
                      ? _c("div", { staticClass: "resource_tag" }, [
                          _c("i", { staticClass: "file" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("文件")]),
                          _vm._v(" "),
                          data.taskType === 1 && _vm.sign != "preview"
                            ? _c("img", {
                                attrs: {
                                  src:
                                    data.isFinish === 1
                                      ? _vm.isFinish
                                      : _vm.unFinish
                                }
                              })
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    data.type == 3
                      ? _c("div", { staticClass: "resource_tag" }, [
                          _c("i", { staticClass: "audio" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("音频")]),
                          _vm._v(" "),
                          data.taskType === 1 && _vm.sign != "preview"
                            ? _c("img", {
                                attrs: {
                                  src:
                                    data.isFinish === 1
                                      ? _vm.isFinish
                                      : _vm.unFinish
                                }
                              })
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    data.type == 4
                      ? _c("div", { staticClass: "resource_tag" }, [
                          _c("i", { staticClass: "video" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("视频")]),
                          _vm._v(" "),
                          data.taskType === 1 && _vm.sign != "preview"
                            ? _c("img", {
                                attrs: {
                                  src:
                                    data.isFinish === 1
                                      ? _vm.isFinish
                                      : _vm.unFinish
                                }
                              })
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    data.resourceType == 3
                      ? _c("div", { staticClass: "resource_tag" }, [
                          _c("i", { staticClass: "shiti" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("实训题")]),
                          _vm._v(" "),
                          data.taskType === 1 && _vm.sign != "preview"
                            ? _c("img", {
                                attrs: {
                                  src:
                                    data.isFinish === 1
                                      ? _vm.isFinish
                                      : _vm.unFinish
                                }
                              })
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    data.resourceType == 5
                      ? _c("div", { staticClass: "resource_tag" }, [
                          _c("i", { staticClass: "test" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("测验")]),
                          _vm._v(" "),
                          data.taskType === 1 && _vm.sign != "preview"
                            ? _c("img", {
                                attrs: {
                                  src:
                                    data.isFinish === 1
                                      ? _vm.isFinish
                                      : _vm.unFinish
                                }
                              })
                            : _vm._e()
                        ])
                      : _vm._e()
                  ]
                )
              ]
            )
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "swiper-button-prev",
              attrs: { slot: "button-prev" },
              slot: "button-prev"
            },
            [_c("i", { staticClass: "el-icon-arrow-left" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "swiper-button-next",
              attrs: { slot: "button-next" },
              slot: "button-next"
            },
            [_c("i", { staticClass: "el-icon-arrow-right" })]
          )
        ],
        2
      ),
      _vm._v(" "),
      !_vm.isShowNote
        ? _c(
            "div",
            { staticClass: "switch_btn", on: { click: _vm.switchRight } },
            [_c("img", { attrs: { src: _vm.switchPic, alt: "" } })]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73c54bcd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73c54bcd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subcomponent/miniSwiper/miniSwiper.vue
// module id = null
// module chunks = 